import { getFilterFromQueryString } from '../util/query-string';

export default function getDefaultFilter(entity, { QueryString }) {
  return getFilterFromQueryString(QueryString);
}
